import { render, staticRenderFns } from "./FacebookOffline.vue?vue&type=template&id=0bc8a36c"
import script from "./FacebookOffline.vue?vue&type=script&lang=js"
export * from "./FacebookOffline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports